import type { NamedValue, ResourcePath } from "@intlify/core-base";
// eslint-disable-next-line no-restricted-imports
import { useI18n as useI18nOriginal } from "vue-i18n";
import type fr from "../i18n/fr.json";

type MessageSchema = typeof fr;

export type MessageKey = ResourcePath<MessageSchema>;

export function useI18n() {
  const { t, ...rest } = useI18nOriginal();

  const strictT = (key: MessageKey, named?: NamedValue) => {
    return named ? t(key, named) : t(key);
  };

  return {
    t: strictT,
    ...rest,
  };
}
